import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type ShoppingCartDetailsFragment = { __typename?: 'ShoppingCartStateData', cartId: string, tenantId: string, shopperId: string, createdAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, status: Types.ShoppingCartStatus, customer: { __typename?: 'ShoppingCartCustomerData', customerId: string, name: string }, items: Array<{ __typename?: 'ShoppingCartItemData', id: string, itemId: string, sku: string, upc: string, itemGroup: string, quantity: number, price: number, name: string, dateAdded: Types.TDateISO }> };

export type UpdatePortalSettingsMutationVariables = Types.Exact<{
  input: Types.UpdatePortalSettingsInput;
}>;


export type UpdatePortalSettingsMutation = { __typename?: 'Mutation', updatePortalSettings: { __typename?: 'PortalSettingsPayload', portalSettings?: { __typename?: 'PortalSettingsStateData', tenantId: string, hasSavedSettings: boolean, portalEnabled: boolean, minimumOrderAmount: number, selfRegistrationEnabled: boolean, buyerContactEditingEnabled: boolean, catalogDisplayMode: Types.CatalogDisplayMode, availabilityMinGrade: number, availabilityLocationId?: string | null, includeSellableHardGoods: boolean, companySlug: string, preferAvailabilityImage: boolean, orderCutoffTime?: string | null, orderCutoffTimeZoneId?: string | null, orderCutoffLeadDays: number, showGradeOnPortal: boolean, portalMaxDaysOut: number, availabilityReportId?: string | null, prePricingEnabled: boolean, portalAutoAcknowledge: boolean, portalAutoAllocate: boolean, portalAutoAllocateStrategy: Types.PortalAutoAllocateStrategy, portalCheckoutOrderStatus: Types.PortalCheckoutOrderStatus, primaryCustomDomain?: string | null, checkoutMethod: Types.PortalCheckoutMethod, priceLabels: Array<{ __typename?: 'PortalPriceLabel', priceLabelId: string, name: string, flatPrice: number, isDefault: boolean }>, deliveryBlackouts: Array<{ __typename?: 'PortalDeliveryBlackoutData', startDate: string, endDate: string }>, customDomains: Array<{ __typename?: 'PortalCustomDomainData', domain: string, status: Types.PortalCustomDomainStatus, verificationRecordHost: string, verificationRecordValue: string, verifiedAt?: Types.TDateISO | null, isPrimary: boolean }>, helpContact?: { __typename?: 'PortalHelpContactData', name: string, email: string } | null, orderContact?: { __typename?: 'PortalOrderContactData', name?: string | null, phone: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ChangePortalHelpContactMutationVariables = Types.Exact<{
  input: Types.ChangePortalHelpContactInput;
}>;


export type ChangePortalHelpContactMutation = { __typename?: 'Mutation', changePortalHelpContact: { __typename?: 'PortalSettingsPayload', portalSettings?: { __typename?: 'PortalSettingsStateData', tenantId: string, hasSavedSettings: boolean, portalEnabled: boolean, minimumOrderAmount: number, selfRegistrationEnabled: boolean, buyerContactEditingEnabled: boolean, catalogDisplayMode: Types.CatalogDisplayMode, availabilityMinGrade: number, availabilityLocationId?: string | null, includeSellableHardGoods: boolean, companySlug: string, preferAvailabilityImage: boolean, orderCutoffTime?: string | null, orderCutoffTimeZoneId?: string | null, orderCutoffLeadDays: number, showGradeOnPortal: boolean, portalMaxDaysOut: number, availabilityReportId?: string | null, prePricingEnabled: boolean, portalAutoAcknowledge: boolean, portalAutoAllocate: boolean, portalAutoAllocateStrategy: Types.PortalAutoAllocateStrategy, portalCheckoutOrderStatus: Types.PortalCheckoutOrderStatus, primaryCustomDomain?: string | null, checkoutMethod: Types.PortalCheckoutMethod, priceLabels: Array<{ __typename?: 'PortalPriceLabel', priceLabelId: string, name: string, flatPrice: number, isDefault: boolean }>, deliveryBlackouts: Array<{ __typename?: 'PortalDeliveryBlackoutData', startDate: string, endDate: string }>, customDomains: Array<{ __typename?: 'PortalCustomDomainData', domain: string, status: Types.PortalCustomDomainStatus, verificationRecordHost: string, verificationRecordValue: string, verifiedAt?: Types.TDateISO | null, isPrimary: boolean }>, helpContact?: { __typename?: 'PortalHelpContactData', name: string, email: string } | null, orderContact?: { __typename?: 'PortalOrderContactData', name?: string | null, phone: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ChangePortalCheckoutMethodMutationVariables = Types.Exact<{
  input: Types.ChangePortalCheckoutMethodInput;
}>;


export type ChangePortalCheckoutMethodMutation = { __typename?: 'Mutation', changePortalCheckoutMethod: { __typename?: 'PortalSettingsPayload', portalSettings?: { __typename?: 'PortalSettingsStateData', tenantId: string, hasSavedSettings: boolean, portalEnabled: boolean, minimumOrderAmount: number, selfRegistrationEnabled: boolean, buyerContactEditingEnabled: boolean, catalogDisplayMode: Types.CatalogDisplayMode, availabilityMinGrade: number, availabilityLocationId?: string | null, includeSellableHardGoods: boolean, companySlug: string, preferAvailabilityImage: boolean, orderCutoffTime?: string | null, orderCutoffTimeZoneId?: string | null, orderCutoffLeadDays: number, showGradeOnPortal: boolean, portalMaxDaysOut: number, availabilityReportId?: string | null, prePricingEnabled: boolean, portalAutoAcknowledge: boolean, portalAutoAllocate: boolean, portalAutoAllocateStrategy: Types.PortalAutoAllocateStrategy, portalCheckoutOrderStatus: Types.PortalCheckoutOrderStatus, primaryCustomDomain?: string | null, checkoutMethod: Types.PortalCheckoutMethod, priceLabels: Array<{ __typename?: 'PortalPriceLabel', priceLabelId: string, name: string, flatPrice: number, isDefault: boolean }>, deliveryBlackouts: Array<{ __typename?: 'PortalDeliveryBlackoutData', startDate: string, endDate: string }>, customDomains: Array<{ __typename?: 'PortalCustomDomainData', domain: string, status: Types.PortalCustomDomainStatus, verificationRecordHost: string, verificationRecordValue: string, verifiedAt?: Types.TDateISO | null, isPrimary: boolean }>, helpContact?: { __typename?: 'PortalHelpContactData', name: string, email: string } | null, orderContact?: { __typename?: 'PortalOrderContactData', name?: string | null, phone: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ChangePortalAvailabilityRuleMutationVariables = Types.Exact<{
  input: Types.ChangePortalAvailabilityRuleInput;
}>;


export type ChangePortalAvailabilityRuleMutation = { __typename?: 'Mutation', changePortalAvailabilityRule: { __typename?: 'PortalSettingsPayload', portalSettings?: { __typename?: 'PortalSettingsStateData', tenantId: string, hasSavedSettings: boolean, portalEnabled: boolean, minimumOrderAmount: number, selfRegistrationEnabled: boolean, buyerContactEditingEnabled: boolean, catalogDisplayMode: Types.CatalogDisplayMode, availabilityMinGrade: number, availabilityLocationId?: string | null, includeSellableHardGoods: boolean, companySlug: string, preferAvailabilityImage: boolean, orderCutoffTime?: string | null, orderCutoffTimeZoneId?: string | null, orderCutoffLeadDays: number, showGradeOnPortal: boolean, portalMaxDaysOut: number, availabilityReportId?: string | null, prePricingEnabled: boolean, portalAutoAcknowledge: boolean, portalAutoAllocate: boolean, portalAutoAllocateStrategy: Types.PortalAutoAllocateStrategy, portalCheckoutOrderStatus: Types.PortalCheckoutOrderStatus, primaryCustomDomain?: string | null, checkoutMethod: Types.PortalCheckoutMethod, priceLabels: Array<{ __typename?: 'PortalPriceLabel', priceLabelId: string, name: string, flatPrice: number, isDefault: boolean }>, deliveryBlackouts: Array<{ __typename?: 'PortalDeliveryBlackoutData', startDate: string, endDate: string }>, customDomains: Array<{ __typename?: 'PortalCustomDomainData', domain: string, status: Types.PortalCustomDomainStatus, verificationRecordHost: string, verificationRecordValue: string, verifiedAt?: Types.TDateISO | null, isPrimary: boolean }>, helpContact?: { __typename?: 'PortalHelpContactData', name: string, email: string } | null, orderContact?: { __typename?: 'PortalOrderContactData', name?: string | null, phone: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddPortalCustomDomainMutationVariables = Types.Exact<{
  input: Types.AddPortalCustomDomainInput;
}>;


export type AddPortalCustomDomainMutation = { __typename?: 'Mutation', addPortalCustomDomain: { __typename?: 'PortalSettingsPayload', portalSettings?: { __typename?: 'PortalSettingsStateData', tenantId: string, hasSavedSettings: boolean, portalEnabled: boolean, minimumOrderAmount: number, selfRegistrationEnabled: boolean, buyerContactEditingEnabled: boolean, catalogDisplayMode: Types.CatalogDisplayMode, availabilityMinGrade: number, availabilityLocationId?: string | null, includeSellableHardGoods: boolean, companySlug: string, preferAvailabilityImage: boolean, orderCutoffTime?: string | null, orderCutoffTimeZoneId?: string | null, orderCutoffLeadDays: number, showGradeOnPortal: boolean, portalMaxDaysOut: number, availabilityReportId?: string | null, prePricingEnabled: boolean, portalAutoAcknowledge: boolean, portalAutoAllocate: boolean, portalAutoAllocateStrategy: Types.PortalAutoAllocateStrategy, portalCheckoutOrderStatus: Types.PortalCheckoutOrderStatus, primaryCustomDomain?: string | null, checkoutMethod: Types.PortalCheckoutMethod, priceLabels: Array<{ __typename?: 'PortalPriceLabel', priceLabelId: string, name: string, flatPrice: number, isDefault: boolean }>, deliveryBlackouts: Array<{ __typename?: 'PortalDeliveryBlackoutData', startDate: string, endDate: string }>, customDomains: Array<{ __typename?: 'PortalCustomDomainData', domain: string, status: Types.PortalCustomDomainStatus, verificationRecordHost: string, verificationRecordValue: string, verifiedAt?: Types.TDateISO | null, isPrimary: boolean }>, helpContact?: { __typename?: 'PortalHelpContactData', name: string, email: string } | null, orderContact?: { __typename?: 'PortalOrderContactData', name?: string | null, phone: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type VerifyPortalCustomDomainMutationVariables = Types.Exact<{
  input: Types.VerifyPortalCustomDomainInput;
}>;


export type VerifyPortalCustomDomainMutation = { __typename?: 'Mutation', verifyPortalCustomDomain: { __typename?: 'PortalSettingsPayload', portalSettings?: { __typename?: 'PortalSettingsStateData', tenantId: string, hasSavedSettings: boolean, portalEnabled: boolean, minimumOrderAmount: number, selfRegistrationEnabled: boolean, buyerContactEditingEnabled: boolean, catalogDisplayMode: Types.CatalogDisplayMode, availabilityMinGrade: number, availabilityLocationId?: string | null, includeSellableHardGoods: boolean, companySlug: string, preferAvailabilityImage: boolean, orderCutoffTime?: string | null, orderCutoffTimeZoneId?: string | null, orderCutoffLeadDays: number, showGradeOnPortal: boolean, portalMaxDaysOut: number, availabilityReportId?: string | null, prePricingEnabled: boolean, portalAutoAcknowledge: boolean, portalAutoAllocate: boolean, portalAutoAllocateStrategy: Types.PortalAutoAllocateStrategy, portalCheckoutOrderStatus: Types.PortalCheckoutOrderStatus, primaryCustomDomain?: string | null, checkoutMethod: Types.PortalCheckoutMethod, priceLabels: Array<{ __typename?: 'PortalPriceLabel', priceLabelId: string, name: string, flatPrice: number, isDefault: boolean }>, deliveryBlackouts: Array<{ __typename?: 'PortalDeliveryBlackoutData', startDate: string, endDate: string }>, customDomains: Array<{ __typename?: 'PortalCustomDomainData', domain: string, status: Types.PortalCustomDomainStatus, verificationRecordHost: string, verificationRecordValue: string, verifiedAt?: Types.TDateISO | null, isPrimary: boolean }>, helpContact?: { __typename?: 'PortalHelpContactData', name: string, email: string } | null, orderContact?: { __typename?: 'PortalOrderContactData', name?: string | null, phone: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetPrimaryPortalCustomDomainMutationVariables = Types.Exact<{
  input: Types.SetPrimaryPortalCustomDomainInput;
}>;


export type SetPrimaryPortalCustomDomainMutation = { __typename?: 'Mutation', setPrimaryPortalCustomDomain: { __typename?: 'PortalSettingsPayload', portalSettings?: { __typename?: 'PortalSettingsStateData', tenantId: string, hasSavedSettings: boolean, portalEnabled: boolean, minimumOrderAmount: number, selfRegistrationEnabled: boolean, buyerContactEditingEnabled: boolean, catalogDisplayMode: Types.CatalogDisplayMode, availabilityMinGrade: number, availabilityLocationId?: string | null, includeSellableHardGoods: boolean, companySlug: string, preferAvailabilityImage: boolean, orderCutoffTime?: string | null, orderCutoffTimeZoneId?: string | null, orderCutoffLeadDays: number, showGradeOnPortal: boolean, portalMaxDaysOut: number, availabilityReportId?: string | null, prePricingEnabled: boolean, portalAutoAcknowledge: boolean, portalAutoAllocate: boolean, portalAutoAllocateStrategy: Types.PortalAutoAllocateStrategy, portalCheckoutOrderStatus: Types.PortalCheckoutOrderStatus, primaryCustomDomain?: string | null, checkoutMethod: Types.PortalCheckoutMethod, priceLabels: Array<{ __typename?: 'PortalPriceLabel', priceLabelId: string, name: string, flatPrice: number, isDefault: boolean }>, deliveryBlackouts: Array<{ __typename?: 'PortalDeliveryBlackoutData', startDate: string, endDate: string }>, customDomains: Array<{ __typename?: 'PortalCustomDomainData', domain: string, status: Types.PortalCustomDomainStatus, verificationRecordHost: string, verificationRecordValue: string, verifiedAt?: Types.TDateISO | null, isPrimary: boolean }>, helpContact?: { __typename?: 'PortalHelpContactData', name: string, email: string } | null, orderContact?: { __typename?: 'PortalOrderContactData', name?: string | null, phone: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemovePortalCustomDomainMutationVariables = Types.Exact<{
  input: Types.RemovePortalCustomDomainInput;
}>;


export type RemovePortalCustomDomainMutation = { __typename?: 'Mutation', removePortalCustomDomain: { __typename?: 'PortalSettingsPayload', portalSettings?: { __typename?: 'PortalSettingsStateData', tenantId: string, hasSavedSettings: boolean, portalEnabled: boolean, minimumOrderAmount: number, selfRegistrationEnabled: boolean, buyerContactEditingEnabled: boolean, catalogDisplayMode: Types.CatalogDisplayMode, availabilityMinGrade: number, availabilityLocationId?: string | null, includeSellableHardGoods: boolean, companySlug: string, preferAvailabilityImage: boolean, orderCutoffTime?: string | null, orderCutoffTimeZoneId?: string | null, orderCutoffLeadDays: number, showGradeOnPortal: boolean, portalMaxDaysOut: number, availabilityReportId?: string | null, prePricingEnabled: boolean, portalAutoAcknowledge: boolean, portalAutoAllocate: boolean, portalAutoAllocateStrategy: Types.PortalAutoAllocateStrategy, portalCheckoutOrderStatus: Types.PortalCheckoutOrderStatus, primaryCustomDomain?: string | null, checkoutMethod: Types.PortalCheckoutMethod, priceLabels: Array<{ __typename?: 'PortalPriceLabel', priceLabelId: string, name: string, flatPrice: number, isDefault: boolean }>, deliveryBlackouts: Array<{ __typename?: 'PortalDeliveryBlackoutData', startDate: string, endDate: string }>, customDomains: Array<{ __typename?: 'PortalCustomDomainData', domain: string, status: Types.PortalCustomDomainStatus, verificationRecordHost: string, verificationRecordValue: string, verifiedAt?: Types.TDateISO | null, isPrimary: boolean }>, helpContact?: { __typename?: 'PortalHelpContactData', name: string, email: string } | null, orderContact?: { __typename?: 'PortalOrderContactData', name?: string | null, phone: string } | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CustomerPortalSelfRegisterMutationVariables = Types.Exact<{
  input: Types.SelfRegisterPortalUserDataInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type CustomerPortalSelfRegisterMutation = { __typename?: 'Mutation', customerPortalSelfRegister: { __typename?: 'UserPayload', user?: { __typename?: 'UserDocument', id: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalCreateCartMutationVariables = Types.Exact<{
  input: Types.CreateCartInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalCreateCartMutation = { __typename?: 'Mutation', customerPortalCreateShoppingCart: { __typename?: 'ShoppingCartPayload', shoppingCart?: { __typename?: 'ShoppingCartStateData', cartId: string, tenantId: string, shopperId: string, createdAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, status: Types.ShoppingCartStatus, customer: { __typename?: 'ShoppingCartCustomerData', customerId: string, name: string }, items: Array<{ __typename?: 'ShoppingCartItemData', id: string, itemId: string, sku: string, upc: string, itemGroup: string, quantity: number, price: number, name: string, dateAdded: Types.TDateISO }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalUpdateCartMutationVariables = Types.Exact<{
  input: Types.UpdateCartInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalUpdateCartMutation = { __typename?: 'Mutation', customerPortalUpdateShoppingCart: { __typename?: 'ShoppingCartPayload', shoppingCart?: { __typename?: 'ShoppingCartStateData', cartId: string, tenantId: string, shopperId: string, createdAt: Types.TDateISO, expectedDeliveryDate: Types.TDateISO, status: Types.ShoppingCartStatus, customer: { __typename?: 'ShoppingCartCustomerData', customerId: string, name: string }, items: Array<{ __typename?: 'ShoppingCartItemData', id: string, itemId: string, sku: string, upc: string, itemGroup: string, quantity: number, price: number, name: string, dateAdded: Types.TDateISO }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalOrderRefFragment = { __typename?: 'OrderStateData', orderId: string, tenantId: string, orderNumber: string, status: Types.OrderStatus };

export type PortalInitializeOrderMutationVariables = Types.Exact<{
  input: Types.InitializeOrderInput;
  tenantId: Types.Scalars['String']['input'];
  note?: Types.InputMaybe<Types.Scalars['String']['input']>;
  isPreorder?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type PortalInitializeOrderMutation = { __typename?: 'Mutation', customerPortalInitializeOrder: { __typename?: 'OrderPayload', order?: { __typename?: 'OrderStateData', orderId: string, tenantId: string, orderNumber: string, status: Types.OrderStatus } | null, deliveryDateRejection?: { __typename?: 'PortalDeliveryDateRejectionData', requestedDate: string, reason: Types.DeliveryDateIneligibleReason, allowedDays: Array<Types.DayOfWeek>, earliestEligibleDate?: string | null } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalAddLineItemsMutationVariables = Types.Exact<{
  input: Types.AddLineItemsInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalAddLineItemsMutation = { __typename?: 'Mutation', customerPortalAddLineItems: { __typename?: 'OrderPayload', order?: { __typename?: 'OrderStateData', orderId: string, tenantId: string, orderNumber: string, status: Types.OrderStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, availabilityShortfalls?: Array<{ __typename?: 'PortalAvailabilityShortfallData', itemId: string, availableQuantity: number, asOfDate?: string | null, nextReadyDate?: string | null, nextReadyQuantity?: number | null }> | null } };

export type PortalUpdateOrderStatusMutationVariables = Types.Exact<{
  input: Types.UpdateOrderStatusInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalUpdateOrderStatusMutation = { __typename?: 'Mutation', customerPortalUpdateOrderStatus: { __typename?: 'OrderPayload', order?: { __typename?: 'OrderStateData', orderId: string, tenantId: string, orderNumber: string, status: Types.OrderStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalDeleteEmptyOrderMutationVariables = Types.Exact<{
  input: Types.DeleteOrderInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalDeleteEmptyOrderMutation = { __typename?: 'Mutation', customerPortalDeleteEmptyOrder: { __typename?: 'OrderPayload', order?: { __typename?: 'OrderStateData', orderId: string, tenantId: string, orderNumber: string, status: Types.OrderStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalCompleteCheckoutMutationVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalCompleteCheckoutMutation = { __typename?: 'Mutation', customerPortalCompleteCheckout: { __typename?: 'OrderPayload', order?: { __typename?: 'OrderStateData', orderId: string, tenantId: string, orderNumber: string, status: Types.OrderStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalGetNextOrderNumberMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalGetNextOrderNumberMutation = { __typename?: 'Mutation', customerPortalUpdateAndGetNextOrderNumber?: { __typename?: 'NextOrderNumberPayload', nextOrderNumber: number } | null };

export type PortalCreateFavoritesListMutationVariables = Types.Exact<{
  input: Types.CreateFavoritesListInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalCreateFavoritesListMutation = { __typename?: 'Mutation', customerPortalCreateFavoritesList: { __typename?: 'FavoritesListPayload', favoritesList?: { __typename?: 'FavoritesListDocument', id: string, favoritesListId: string, tenantId: string, name: string, description: string, scope: number, scopeId: string, createdBy: string, createdDate: Types.TDateISO, lastModified: Types.TDateISO, status: number, items: Array<{ __typename?: 'FavoritesListItemDocument', id: string, itemId: string, quantity: number, sortOrder: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalUpdateFavoritesListMutationVariables = Types.Exact<{
  input: Types.UpdateFavoritesListInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalUpdateFavoritesListMutation = { __typename?: 'Mutation', customerPortalUpdateFavoritesList: { __typename?: 'FavoritesListPayload', favoritesList?: { __typename?: 'FavoritesListDocument', id: string, favoritesListId: string, tenantId: string, name: string, description: string, scope: number, scopeId: string, createdBy: string, createdDate: Types.TDateISO, lastModified: Types.TDateISO, status: number, items: Array<{ __typename?: 'FavoritesListItemDocument', id: string, itemId: string, quantity: number, sortOrder: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalDeleteFavoritesListMutationVariables = Types.Exact<{
  input: Types.DeleteFavoritesListInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalDeleteFavoritesListMutation = { __typename?: 'Mutation', customerPortalDeleteFavoritesList: { __typename?: 'FavoritesListPayload', favoritesList?: { __typename?: 'FavoritesListDocument', id: string, favoritesListId: string, tenantId: string, name: string, description: string, scope: number, scopeId: string, createdBy: string, createdDate: Types.TDateISO, lastModified: Types.TDateISO, status: number, items: Array<{ __typename?: 'FavoritesListItemDocument', id: string, itemId: string, quantity: number, sortOrder: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalSetFavoritesListActiveMutationVariables = Types.Exact<{
  input: Types.SetFavoritesListActiveInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalSetFavoritesListActiveMutation = { __typename?: 'Mutation', customerPortalSetFavoritesListActive: { __typename?: 'FavoritesListPayload', favoritesList?: { __typename?: 'FavoritesListDocument', id: string, favoritesListId: string, tenantId: string, name: string, description: string, scope: number, scopeId: string, createdBy: string, createdDate: Types.TDateISO, lastModified: Types.TDateISO, status: number, items: Array<{ __typename?: 'FavoritesListItemDocument', id: string, itemId: string, quantity: number, sortOrder: number }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalSessionHandoffMintDetailsFragment = { __typename?: 'PortalSessionHandoffMintData', code: string, expiresAt: Types.TDateISO, targetDomain: string };

export type PortalSessionHandoffSessionDetailsFragment = { __typename?: 'PortalSessionHandoffSessionData', sessionMaterial: string, targetDomain: string, tenantId: string };

export type MintPortalSessionHandoffCodeMutationVariables = Types.Exact<{
  input: Types.MintPortalSessionHandoffCodeInput;
}>;


export type MintPortalSessionHandoffCodeMutation = { __typename?: 'Mutation', mintPortalSessionHandoffCode: { __typename?: 'PortalSessionHandoffMintPayload', handoff?: { __typename?: 'PortalSessionHandoffMintData', code: string, expiresAt: Types.TDateISO, targetDomain: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type ExchangePortalSessionHandoffCodeMutationVariables = Types.Exact<{
  input: Types.ExchangePortalSessionHandoffCodeInput;
}>;


export type ExchangePortalSessionHandoffCodeMutation = { __typename?: 'Mutation', exchangePortalSessionHandoffCode: { __typename?: 'PortalSessionHandoffExchangePayload', session?: { __typename?: 'PortalSessionHandoffSessionData', sessionMaterial: string, targetDomain: string, tenantId: string } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalAddContactMutationVariables = Types.Exact<{
  input: Types.CustomerPortalAddContactInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalAddContactMutation = { __typename?: 'Mutation', customerPortalAddContact: { __typename?: 'CustomerPortalAccountPayload', account?: { __typename?: 'CustomerPortalAccountData', customerId: string, name: string, erpId: string, termsId: string, priceGroupId: string, effectiveOrderEntryUnit: Types.OrderEntryUnit, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, locations: Array<{ __typename?: 'CustomerPortalLocationData', id: string, code: string, name: string, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> }>, contacts: Array<{ __typename?: 'CustomerPortalContactData', id: string, type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }>, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }> }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalUpdateContactMutationVariables = Types.Exact<{
  input: Types.CustomerPortalUpdateContactInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalUpdateContactMutation = { __typename?: 'Mutation', customerPortalUpdateContact: { __typename?: 'CustomerPortalAccountPayload', account?: { __typename?: 'CustomerPortalAccountData', customerId: string, name: string, erpId: string, termsId: string, priceGroupId: string, effectiveOrderEntryUnit: Types.OrderEntryUnit, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, locations: Array<{ __typename?: 'CustomerPortalLocationData', id: string, code: string, name: string, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> }>, contacts: Array<{ __typename?: 'CustomerPortalContactData', id: string, type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }>, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }> }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalRemoveContactMutationVariables = Types.Exact<{
  input: Types.CustomerPortalRemoveContactInput;
  tenantId: Types.Scalars['String']['input'];
}>;


export type PortalRemoveContactMutation = { __typename?: 'Mutation', customerPortalRemoveContact: { __typename?: 'CustomerPortalAccountPayload', account?: { __typename?: 'CustomerPortalAccountData', customerId: string, name: string, erpId: string, termsId: string, priceGroupId: string, effectiveOrderEntryUnit: Types.OrderEntryUnit, shipFromLocations: Array<{ __typename?: 'ShipFromLocationData', name: string }>, orderSubmitter?: { __typename?: 'OrderSubmitterData', name?: string | null, phone?: string | null, email?: string | null } | null, billingAddresses: Array<{ __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }>, locations: Array<{ __typename?: 'CustomerPortalLocationData', id: string, code: string, name: string, address: { __typename?: 'CreateAddress', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string }, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> }>, contacts: Array<{ __typename?: 'CustomerPortalContactData', id: string, type: Types.ContactType, firstName: string, lastName: string, title: string, phoneNumbers: Array<{ __typename?: 'PhoneNumberData', type: Types.PhoneNumberType, value: string }>, emailAddresses: Array<{ __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string }> }>, salesPeople: Array<{ __typename?: 'SalesPersonData', emailAddress: { __typename?: 'EmailAddressData', type: Types.EmailAddressType, value: string } }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type PortalPlaceOrderMutationVariables = Types.Exact<{
  tenantId: Types.Scalars['String']['input'];
  orderId: Types.Scalars['String']['input'];
  header: Types.CustomerPortalPlaceOrderHeaderDataInput;
  lines: Array<Types.AddLineItemDataInput> | Types.AddLineItemDataInput;
  note?: Types.InputMaybe<Types.Scalars['String']['input']>;
  isPreorder?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type PortalPlaceOrderMutation = { __typename?: 'Mutation', customerPortalPlaceOrder: { __typename?: 'CustomerPortalPlaceOrderPayload', result?: Types.CustomerPortalPlaceOrderResult | null, order?: { __typename?: 'OrderStateData', orderId: string, tenantId: string, orderNumber: string, status: Types.OrderStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, deliveryDateRejection?: { __typename?: 'PortalDeliveryDateRejectionData', requestedDate: string, reason: Types.DeliveryDateIneligibleReason, allowedDays: Array<Types.DayOfWeek>, earliestEligibleDate?: string | null } | null, availabilityShortfalls?: Array<{ __typename?: 'PortalAvailabilityShortfallData', itemId: string, availableQuantity: number, asOfDate?: string | null, nextReadyDate?: string | null, nextReadyQuantity?: number | null }> | null } };

export const ShoppingCartDetailsFragmentDoc = new TypedDocumentString(`
    fragment ShoppingCartDetails on ShoppingCartStateData {
  cartId
  tenantId
  shopperId
  createdAt
  expectedDeliveryDate
  status
  customer {
    customerId
    name
  }
  items {
    id
    itemId
    sku
    upc
    itemGroup
    quantity
    price
    name
    dateAdded
  }
}
    `, {"fragmentName":"ShoppingCartDetails"});
export const PortalOrderRefFragmentDoc = new TypedDocumentString(`
    fragment PortalOrderRef on OrderStateData {
  orderId
  tenantId
  orderNumber
  status
}
    `, {"fragmentName":"PortalOrderRef"});
export const PortalSessionHandoffMintDetailsFragmentDoc = new TypedDocumentString(`
    fragment PortalSessionHandoffMintDetails on PortalSessionHandoffMintData {
  code
  expiresAt
  targetDomain
}
    `, {"fragmentName":"PortalSessionHandoffMintDetails"});
export const PortalSessionHandoffSessionDetailsFragmentDoc = new TypedDocumentString(`
    fragment PortalSessionHandoffSessionDetails on PortalSessionHandoffSessionData {
  sessionMaterial
  targetDomain
  tenantId
}
    `, {"fragmentName":"PortalSessionHandoffSessionDetails"});
export const UpdatePortalSettingsDocument = new TypedDocumentString(`
    mutation UpdatePortalSettings($input: UpdatePortalSettingsInput!) {
  updatePortalSettings(input: $input) {
    portalSettings {
      ...PortalSettingsFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalSettingsFields on PortalSettingsStateData {
  tenantId
  hasSavedSettings
  portalEnabled
  minimumOrderAmount
  selfRegistrationEnabled
  buyerContactEditingEnabled
  catalogDisplayMode
  availabilityMinGrade
  availabilityLocationId
  includeSellableHardGoods
  companySlug
  preferAvailabilityImage
  orderCutoffTime
  orderCutoffTimeZoneId
  orderCutoffLeadDays
  showGradeOnPortal
  portalMaxDaysOut
  availabilityReportId
  prePricingEnabled
  priceLabels {
    priceLabelId
    name
    flatPrice
    isDefault
  }
  portalAutoAcknowledge
  portalAutoAllocate
  portalAutoAllocateStrategy
  portalCheckoutOrderStatus
  deliveryBlackouts {
    ...PortalDeliveryBlackoutFields
  }
  customDomains {
    ...PortalCustomDomainFields
  }
  primaryCustomDomain
  helpContact {
    ...PortalHelpContactFields
  }
  checkoutMethod
  orderContact {
    ...PortalOrderContactFields
  }
}
fragment PortalDeliveryBlackoutFields on PortalDeliveryBlackoutData {
  startDate
  endDate
}
fragment PortalCustomDomainFields on PortalCustomDomainData {
  domain
  status
  verificationRecordHost
  verificationRecordValue
  verifiedAt
  isPrimary
}
fragment PortalHelpContactFields on PortalHelpContactData {
  name
  email
}
fragment PortalOrderContactFields on PortalOrderContactData {
  name
  phone
}`);
export const ChangePortalHelpContactDocument = new TypedDocumentString(`
    mutation ChangePortalHelpContact($input: ChangePortalHelpContactInput!) {
  changePortalHelpContact(input: $input) {
    portalSettings {
      ...PortalSettingsFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalSettingsFields on PortalSettingsStateData {
  tenantId
  hasSavedSettings
  portalEnabled
  minimumOrderAmount
  selfRegistrationEnabled
  buyerContactEditingEnabled
  catalogDisplayMode
  availabilityMinGrade
  availabilityLocationId
  includeSellableHardGoods
  companySlug
  preferAvailabilityImage
  orderCutoffTime
  orderCutoffTimeZoneId
  orderCutoffLeadDays
  showGradeOnPortal
  portalMaxDaysOut
  availabilityReportId
  prePricingEnabled
  priceLabels {
    priceLabelId
    name
    flatPrice
    isDefault
  }
  portalAutoAcknowledge
  portalAutoAllocate
  portalAutoAllocateStrategy
  portalCheckoutOrderStatus
  deliveryBlackouts {
    ...PortalDeliveryBlackoutFields
  }
  customDomains {
    ...PortalCustomDomainFields
  }
  primaryCustomDomain
  helpContact {
    ...PortalHelpContactFields
  }
  checkoutMethod
  orderContact {
    ...PortalOrderContactFields
  }
}
fragment PortalDeliveryBlackoutFields on PortalDeliveryBlackoutData {
  startDate
  endDate
}
fragment PortalCustomDomainFields on PortalCustomDomainData {
  domain
  status
  verificationRecordHost
  verificationRecordValue
  verifiedAt
  isPrimary
}
fragment PortalHelpContactFields on PortalHelpContactData {
  name
  email
}
fragment PortalOrderContactFields on PortalOrderContactData {
  name
  phone
}`);
export const ChangePortalCheckoutMethodDocument = new TypedDocumentString(`
    mutation ChangePortalCheckoutMethod($input: ChangePortalCheckoutMethodInput!) {
  changePortalCheckoutMethod(input: $input) {
    portalSettings {
      ...PortalSettingsFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalSettingsFields on PortalSettingsStateData {
  tenantId
  hasSavedSettings
  portalEnabled
  minimumOrderAmount
  selfRegistrationEnabled
  buyerContactEditingEnabled
  catalogDisplayMode
  availabilityMinGrade
  availabilityLocationId
  includeSellableHardGoods
  companySlug
  preferAvailabilityImage
  orderCutoffTime
  orderCutoffTimeZoneId
  orderCutoffLeadDays
  showGradeOnPortal
  portalMaxDaysOut
  availabilityReportId
  prePricingEnabled
  priceLabels {
    priceLabelId
    name
    flatPrice
    isDefault
  }
  portalAutoAcknowledge
  portalAutoAllocate
  portalAutoAllocateStrategy
  portalCheckoutOrderStatus
  deliveryBlackouts {
    ...PortalDeliveryBlackoutFields
  }
  customDomains {
    ...PortalCustomDomainFields
  }
  primaryCustomDomain
  helpContact {
    ...PortalHelpContactFields
  }
  checkoutMethod
  orderContact {
    ...PortalOrderContactFields
  }
}
fragment PortalDeliveryBlackoutFields on PortalDeliveryBlackoutData {
  startDate
  endDate
}
fragment PortalCustomDomainFields on PortalCustomDomainData {
  domain
  status
  verificationRecordHost
  verificationRecordValue
  verifiedAt
  isPrimary
}
fragment PortalHelpContactFields on PortalHelpContactData {
  name
  email
}
fragment PortalOrderContactFields on PortalOrderContactData {
  name
  phone
}`);
export const ChangePortalAvailabilityRuleDocument = new TypedDocumentString(`
    mutation ChangePortalAvailabilityRule($input: ChangePortalAvailabilityRuleInput!) {
  changePortalAvailabilityRule(input: $input) {
    portalSettings {
      ...PortalSettingsFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalSettingsFields on PortalSettingsStateData {
  tenantId
  hasSavedSettings
  portalEnabled
  minimumOrderAmount
  selfRegistrationEnabled
  buyerContactEditingEnabled
  catalogDisplayMode
  availabilityMinGrade
  availabilityLocationId
  includeSellableHardGoods
  companySlug
  preferAvailabilityImage
  orderCutoffTime
  orderCutoffTimeZoneId
  orderCutoffLeadDays
  showGradeOnPortal
  portalMaxDaysOut
  availabilityReportId
  prePricingEnabled
  priceLabels {
    priceLabelId
    name
    flatPrice
    isDefault
  }
  portalAutoAcknowledge
  portalAutoAllocate
  portalAutoAllocateStrategy
  portalCheckoutOrderStatus
  deliveryBlackouts {
    ...PortalDeliveryBlackoutFields
  }
  customDomains {
    ...PortalCustomDomainFields
  }
  primaryCustomDomain
  helpContact {
    ...PortalHelpContactFields
  }
  checkoutMethod
  orderContact {
    ...PortalOrderContactFields
  }
}
fragment PortalDeliveryBlackoutFields on PortalDeliveryBlackoutData {
  startDate
  endDate
}
fragment PortalCustomDomainFields on PortalCustomDomainData {
  domain
  status
  verificationRecordHost
  verificationRecordValue
  verifiedAt
  isPrimary
}
fragment PortalHelpContactFields on PortalHelpContactData {
  name
  email
}
fragment PortalOrderContactFields on PortalOrderContactData {
  name
  phone
}`);
export const AddPortalCustomDomainDocument = new TypedDocumentString(`
    mutation AddPortalCustomDomain($input: AddPortalCustomDomainInput!) {
  addPortalCustomDomain(input: $input) {
    portalSettings {
      ...PortalSettingsFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalSettingsFields on PortalSettingsStateData {
  tenantId
  hasSavedSettings
  portalEnabled
  minimumOrderAmount
  selfRegistrationEnabled
  buyerContactEditingEnabled
  catalogDisplayMode
  availabilityMinGrade
  availabilityLocationId
  includeSellableHardGoods
  companySlug
  preferAvailabilityImage
  orderCutoffTime
  orderCutoffTimeZoneId
  orderCutoffLeadDays
  showGradeOnPortal
  portalMaxDaysOut
  availabilityReportId
  prePricingEnabled
  priceLabels {
    priceLabelId
    name
    flatPrice
    isDefault
  }
  portalAutoAcknowledge
  portalAutoAllocate
  portalAutoAllocateStrategy
  portalCheckoutOrderStatus
  deliveryBlackouts {
    ...PortalDeliveryBlackoutFields
  }
  customDomains {
    ...PortalCustomDomainFields
  }
  primaryCustomDomain
  helpContact {
    ...PortalHelpContactFields
  }
  checkoutMethod
  orderContact {
    ...PortalOrderContactFields
  }
}
fragment PortalDeliveryBlackoutFields on PortalDeliveryBlackoutData {
  startDate
  endDate
}
fragment PortalCustomDomainFields on PortalCustomDomainData {
  domain
  status
  verificationRecordHost
  verificationRecordValue
  verifiedAt
  isPrimary
}
fragment PortalHelpContactFields on PortalHelpContactData {
  name
  email
}
fragment PortalOrderContactFields on PortalOrderContactData {
  name
  phone
}`);
export const VerifyPortalCustomDomainDocument = new TypedDocumentString(`
    mutation VerifyPortalCustomDomain($input: VerifyPortalCustomDomainInput!) {
  verifyPortalCustomDomain(input: $input) {
    portalSettings {
      ...PortalSettingsFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalSettingsFields on PortalSettingsStateData {
  tenantId
  hasSavedSettings
  portalEnabled
  minimumOrderAmount
  selfRegistrationEnabled
  buyerContactEditingEnabled
  catalogDisplayMode
  availabilityMinGrade
  availabilityLocationId
  includeSellableHardGoods
  companySlug
  preferAvailabilityImage
  orderCutoffTime
  orderCutoffTimeZoneId
  orderCutoffLeadDays
  showGradeOnPortal
  portalMaxDaysOut
  availabilityReportId
  prePricingEnabled
  priceLabels {
    priceLabelId
    name
    flatPrice
    isDefault
  }
  portalAutoAcknowledge
  portalAutoAllocate
  portalAutoAllocateStrategy
  portalCheckoutOrderStatus
  deliveryBlackouts {
    ...PortalDeliveryBlackoutFields
  }
  customDomains {
    ...PortalCustomDomainFields
  }
  primaryCustomDomain
  helpContact {
    ...PortalHelpContactFields
  }
  checkoutMethod
  orderContact {
    ...PortalOrderContactFields
  }
}
fragment PortalDeliveryBlackoutFields on PortalDeliveryBlackoutData {
  startDate
  endDate
}
fragment PortalCustomDomainFields on PortalCustomDomainData {
  domain
  status
  verificationRecordHost
  verificationRecordValue
  verifiedAt
  isPrimary
}
fragment PortalHelpContactFields on PortalHelpContactData {
  name
  email
}
fragment PortalOrderContactFields on PortalOrderContactData {
  name
  phone
}`);
export const SetPrimaryPortalCustomDomainDocument = new TypedDocumentString(`
    mutation SetPrimaryPortalCustomDomain($input: SetPrimaryPortalCustomDomainInput!) {
  setPrimaryPortalCustomDomain(input: $input) {
    portalSettings {
      ...PortalSettingsFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalSettingsFields on PortalSettingsStateData {
  tenantId
  hasSavedSettings
  portalEnabled
  minimumOrderAmount
  selfRegistrationEnabled
  buyerContactEditingEnabled
  catalogDisplayMode
  availabilityMinGrade
  availabilityLocationId
  includeSellableHardGoods
  companySlug
  preferAvailabilityImage
  orderCutoffTime
  orderCutoffTimeZoneId
  orderCutoffLeadDays
  showGradeOnPortal
  portalMaxDaysOut
  availabilityReportId
  prePricingEnabled
  priceLabels {
    priceLabelId
    name
    flatPrice
    isDefault
  }
  portalAutoAcknowledge
  portalAutoAllocate
  portalAutoAllocateStrategy
  portalCheckoutOrderStatus
  deliveryBlackouts {
    ...PortalDeliveryBlackoutFields
  }
  customDomains {
    ...PortalCustomDomainFields
  }
  primaryCustomDomain
  helpContact {
    ...PortalHelpContactFields
  }
  checkoutMethod
  orderContact {
    ...PortalOrderContactFields
  }
}
fragment PortalDeliveryBlackoutFields on PortalDeliveryBlackoutData {
  startDate
  endDate
}
fragment PortalCustomDomainFields on PortalCustomDomainData {
  domain
  status
  verificationRecordHost
  verificationRecordValue
  verifiedAt
  isPrimary
}
fragment PortalHelpContactFields on PortalHelpContactData {
  name
  email
}
fragment PortalOrderContactFields on PortalOrderContactData {
  name
  phone
}`);
export const RemovePortalCustomDomainDocument = new TypedDocumentString(`
    mutation RemovePortalCustomDomain($input: RemovePortalCustomDomainInput!) {
  removePortalCustomDomain(input: $input) {
    portalSettings {
      ...PortalSettingsFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalSettingsFields on PortalSettingsStateData {
  tenantId
  hasSavedSettings
  portalEnabled
  minimumOrderAmount
  selfRegistrationEnabled
  buyerContactEditingEnabled
  catalogDisplayMode
  availabilityMinGrade
  availabilityLocationId
  includeSellableHardGoods
  companySlug
  preferAvailabilityImage
  orderCutoffTime
  orderCutoffTimeZoneId
  orderCutoffLeadDays
  showGradeOnPortal
  portalMaxDaysOut
  availabilityReportId
  prePricingEnabled
  priceLabels {
    priceLabelId
    name
    flatPrice
    isDefault
  }
  portalAutoAcknowledge
  portalAutoAllocate
  portalAutoAllocateStrategy
  portalCheckoutOrderStatus
  deliveryBlackouts {
    ...PortalDeliveryBlackoutFields
  }
  customDomains {
    ...PortalCustomDomainFields
  }
  primaryCustomDomain
  helpContact {
    ...PortalHelpContactFields
  }
  checkoutMethod
  orderContact {
    ...PortalOrderContactFields
  }
}
fragment PortalDeliveryBlackoutFields on PortalDeliveryBlackoutData {
  startDate
  endDate
}
fragment PortalCustomDomainFields on PortalCustomDomainData {
  domain
  status
  verificationRecordHost
  verificationRecordValue
  verifiedAt
  isPrimary
}
fragment PortalHelpContactFields on PortalHelpContactData {
  name
  email
}
fragment PortalOrderContactFields on PortalOrderContactData {
  name
  phone
}`);
export const CustomerPortalSelfRegisterDocument = new TypedDocumentString(`
    mutation CustomerPortalSelfRegister($input: SelfRegisterPortalUserDataInput!, $tenantId: String!) {
  customerPortalSelfRegister(input: $input, tenantId: $tenantId) {
    user {
      id
    }
    errors {
      code
      message
    }
  }
}
    `);
export const PortalCreateCartDocument = new TypedDocumentString(`
    mutation PortalCreateCart($input: CreateCartInput!, $tenantId: String!) {
  customerPortalCreateShoppingCart(input: $input, tenantId: $tenantId) {
    shoppingCart {
      ...ShoppingCartDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ShoppingCartDetails on ShoppingCartStateData {
  cartId
  tenantId
  shopperId
  createdAt
  expectedDeliveryDate
  status
  customer {
    customerId
    name
  }
  items {
    id
    itemId
    sku
    upc
    itemGroup
    quantity
    price
    name
    dateAdded
  }
}`);
export const PortalUpdateCartDocument = new TypedDocumentString(`
    mutation PortalUpdateCart($input: UpdateCartInput!, $tenantId: String!) {
  customerPortalUpdateShoppingCart(input: $input, tenantId: $tenantId) {
    shoppingCart {
      ...ShoppingCartDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment ShoppingCartDetails on ShoppingCartStateData {
  cartId
  tenantId
  shopperId
  createdAt
  expectedDeliveryDate
  status
  customer {
    customerId
    name
  }
  items {
    id
    itemId
    sku
    upc
    itemGroup
    quantity
    price
    name
    dateAdded
  }
}`);
export const PortalInitializeOrderDocument = new TypedDocumentString(`
    mutation PortalInitializeOrder($input: InitializeOrderInput!, $tenantId: String!, $note: String, $isPreorder: Boolean) {
  customerPortalInitializeOrder(
    input: $input
    tenantId: $tenantId
    note: $note
    isPreorder: $isPreorder
  ) {
    order {
      ...PortalOrderRef
    }
    deliveryDateRejection {
      ...PortalDeliveryDateRejection
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalOrderRef on OrderStateData {
  orderId
  tenantId
  orderNumber
  status
}
fragment PortalDeliveryDateRejection on PortalDeliveryDateRejectionData {
  requestedDate
  reason
  allowedDays
  earliestEligibleDate
}`);
export const PortalAddLineItemsDocument = new TypedDocumentString(`
    mutation PortalAddLineItems($input: AddLineItemsInput!, $tenantId: String!) {
  customerPortalAddLineItems(input: $input, tenantId: $tenantId) {
    order {
      ...PortalOrderRef
    }
    errors {
      code
      message
    }
    availabilityShortfalls {
      itemId
      availableQuantity
      asOfDate
      nextReadyDate
      nextReadyQuantity
    }
  }
}
    fragment PortalOrderRef on OrderStateData {
  orderId
  tenantId
  orderNumber
  status
}`);
export const PortalUpdateOrderStatusDocument = new TypedDocumentString(`
    mutation PortalUpdateOrderStatus($input: UpdateOrderStatusInput!, $tenantId: String!) {
  customerPortalUpdateOrderStatus(input: $input, tenantId: $tenantId) {
    order {
      ...PortalOrderRef
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalOrderRef on OrderStateData {
  orderId
  tenantId
  orderNumber
  status
}`);
export const PortalDeleteEmptyOrderDocument = new TypedDocumentString(`
    mutation PortalDeleteEmptyOrder($input: DeleteOrderInput!, $tenantId: String!) {
  customerPortalDeleteEmptyOrder(input: $input, tenantId: $tenantId) {
    order {
      ...PortalOrderRef
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalOrderRef on OrderStateData {
  orderId
  tenantId
  orderNumber
  status
}`);
export const PortalCompleteCheckoutDocument = new TypedDocumentString(`
    mutation PortalCompleteCheckout($orderId: String!, $tenantId: String!) {
  customerPortalCompleteCheckout(orderId: $orderId, tenantId: $tenantId) {
    order {
      ...PortalOrderRef
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalOrderRef on OrderStateData {
  orderId
  tenantId
  orderNumber
  status
}`);
export const PortalGetNextOrderNumberDocument = new TypedDocumentString(`
    mutation PortalGetNextOrderNumber($tenantId: String!) {
  customerPortalUpdateAndGetNextOrderNumber(tenantId: $tenantId) {
    nextOrderNumber
  }
}
    `);
export const PortalCreateFavoritesListDocument = new TypedDocumentString(`
    mutation PortalCreateFavoritesList($input: CreateFavoritesListInput!, $tenantId: String!) {
  customerPortalCreateFavoritesList(input: $input, tenantId: $tenantId) {
    favoritesList {
      ...FavoritesListFields
    }
    errors {
      code
      message
    }
  }
}
    fragment FavoritesListFields on FavoritesListDocument {
  id
  favoritesListId
  tenantId
  name
  description
  scope
  scopeId
  items {
    id
    itemId
    quantity
    sortOrder
  }
  createdBy
  createdDate
  lastModified
  status
}`);
export const PortalUpdateFavoritesListDocument = new TypedDocumentString(`
    mutation PortalUpdateFavoritesList($input: UpdateFavoritesListInput!, $tenantId: String!) {
  customerPortalUpdateFavoritesList(input: $input, tenantId: $tenantId) {
    favoritesList {
      ...FavoritesListFields
    }
    errors {
      code
      message
    }
  }
}
    fragment FavoritesListFields on FavoritesListDocument {
  id
  favoritesListId
  tenantId
  name
  description
  scope
  scopeId
  items {
    id
    itemId
    quantity
    sortOrder
  }
  createdBy
  createdDate
  lastModified
  status
}`);
export const PortalDeleteFavoritesListDocument = new TypedDocumentString(`
    mutation PortalDeleteFavoritesList($input: DeleteFavoritesListInput!, $tenantId: String!) {
  customerPortalDeleteFavoritesList(input: $input, tenantId: $tenantId) {
    favoritesList {
      ...FavoritesListFields
    }
    errors {
      code
      message
    }
  }
}
    fragment FavoritesListFields on FavoritesListDocument {
  id
  favoritesListId
  tenantId
  name
  description
  scope
  scopeId
  items {
    id
    itemId
    quantity
    sortOrder
  }
  createdBy
  createdDate
  lastModified
  status
}`);
export const PortalSetFavoritesListActiveDocument = new TypedDocumentString(`
    mutation PortalSetFavoritesListActive($input: SetFavoritesListActiveInput!, $tenantId: String!) {
  customerPortalSetFavoritesListActive(input: $input, tenantId: $tenantId) {
    favoritesList {
      ...FavoritesListFields
    }
    errors {
      code
      message
    }
  }
}
    fragment FavoritesListFields on FavoritesListDocument {
  id
  favoritesListId
  tenantId
  name
  description
  scope
  scopeId
  items {
    id
    itemId
    quantity
    sortOrder
  }
  createdBy
  createdDate
  lastModified
  status
}`);
export const MintPortalSessionHandoffCodeDocument = new TypedDocumentString(`
    mutation MintPortalSessionHandoffCode($input: MintPortalSessionHandoffCodeInput!) {
  mintPortalSessionHandoffCode(input: $input) {
    handoff {
      ...PortalSessionHandoffMintDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalSessionHandoffMintDetails on PortalSessionHandoffMintData {
  code
  expiresAt
  targetDomain
}`);
export const ExchangePortalSessionHandoffCodeDocument = new TypedDocumentString(`
    mutation ExchangePortalSessionHandoffCode($input: ExchangePortalSessionHandoffCodeInput!) {
  exchangePortalSessionHandoffCode(input: $input) {
    session {
      ...PortalSessionHandoffSessionDetails
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalSessionHandoffSessionDetails on PortalSessionHandoffSessionData {
  sessionMaterial
  targetDomain
  tenantId
}`);
export const PortalAddContactDocument = new TypedDocumentString(`
    mutation PortalAddContact($input: CustomerPortalAddContactInput!, $tenantId: String!) {
  customerPortalAddContact(input: $input, tenantId: $tenantId) {
    account {
      ...PortalAccountFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalAccountFields on CustomerPortalAccountData {
  customerId
  name
  erpId
  termsId
  priceGroupId
  effectiveOrderEntryUnit
  shipFromLocations {
    name
  }
  orderSubmitter {
    ...OrderSubmitter
  }
  billingAddresses {
    ...Address
  }
  locations {
    id
    code
    name
    address {
      ...Address
    }
    salesPeople {
      ...SalesPerson
    }
  }
  contacts {
    id
    type
    firstName
    lastName
    title
    phoneNumbers {
      type
      value
    }
    emailAddresses {
      type
      value
    }
  }
  salesPeople {
    ...SalesPerson
  }
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`);
export const PortalUpdateContactDocument = new TypedDocumentString(`
    mutation PortalUpdateContact($input: CustomerPortalUpdateContactInput!, $tenantId: String!) {
  customerPortalUpdateContact(input: $input, tenantId: $tenantId) {
    account {
      ...PortalAccountFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalAccountFields on CustomerPortalAccountData {
  customerId
  name
  erpId
  termsId
  priceGroupId
  effectiveOrderEntryUnit
  shipFromLocations {
    name
  }
  orderSubmitter {
    ...OrderSubmitter
  }
  billingAddresses {
    ...Address
  }
  locations {
    id
    code
    name
    address {
      ...Address
    }
    salesPeople {
      ...SalesPerson
    }
  }
  contacts {
    id
    type
    firstName
    lastName
    title
    phoneNumbers {
      type
      value
    }
    emailAddresses {
      type
      value
    }
  }
  salesPeople {
    ...SalesPerson
  }
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`);
export const PortalRemoveContactDocument = new TypedDocumentString(`
    mutation PortalRemoveContact($input: CustomerPortalRemoveContactInput!, $tenantId: String!) {
  customerPortalRemoveContact(input: $input, tenantId: $tenantId) {
    account {
      ...PortalAccountFields
    }
    errors {
      code
      message
    }
  }
}
    fragment PortalAccountFields on CustomerPortalAccountData {
  customerId
  name
  erpId
  termsId
  priceGroupId
  effectiveOrderEntryUnit
  shipFromLocations {
    name
  }
  orderSubmitter {
    ...OrderSubmitter
  }
  billingAddresses {
    ...Address
  }
  locations {
    id
    code
    name
    address {
      ...Address
    }
    salesPeople {
      ...SalesPerson
    }
  }
  contacts {
    id
    type
    firstName
    lastName
    title
    phoneNumbers {
      type
      value
    }
    emailAddresses {
      type
      value
    }
  }
  salesPeople {
    ...SalesPerson
  }
}
fragment OrderSubmitter on OrderSubmitterData {
  name
  phone
  email
}
fragment Address on CreateAddress {
  id
  toName
  addressLine1
  addressLine2
  city
  stateProvince
  zipcode
  country
}
fragment SalesPerson on SalesPersonData {
  emailAddress {
    type
    value
  }
}`);
export const PortalPlaceOrderDocument = new TypedDocumentString(`
    mutation PortalPlaceOrder($tenantId: String!, $orderId: String!, $header: CustomerPortalPlaceOrderHeaderDataInput!, $lines: [AddLineItemDataInput!]!, $note: String, $isPreorder: Boolean) {
  customerPortalPlaceOrder(
    tenantId: $tenantId
    orderId: $orderId
    header: $header
    lines: $lines
    note: $note
    isPreorder: $isPreorder
  ) {
    result
    order {
      ...PortalOrderRef
    }
    errors {
      code
      message
    }
    deliveryDateRejection {
      ...PortalDeliveryDateRejection
    }
    availabilityShortfalls {
      itemId
      availableQuantity
      asOfDate
      nextReadyDate
      nextReadyQuantity
    }
  }
}
    fragment PortalOrderRef on OrderStateData {
  orderId
  tenantId
  orderNumber
  status
}
fragment PortalDeliveryDateRejection on PortalDeliveryDateRejectionData {
  requestedDate
  reason
  allowedDays
  earliestEligibleDate
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    UpdatePortalSettings: build.mutation<UpdatePortalSettingsMutation, UpdatePortalSettingsMutationVariables>({
      query: (variables) => ({ document: UpdatePortalSettingsDocument, variables })
    }),
    ChangePortalHelpContact: build.mutation<ChangePortalHelpContactMutation, ChangePortalHelpContactMutationVariables>({
      query: (variables) => ({ document: ChangePortalHelpContactDocument, variables })
    }),
    ChangePortalCheckoutMethod: build.mutation<ChangePortalCheckoutMethodMutation, ChangePortalCheckoutMethodMutationVariables>({
      query: (variables) => ({ document: ChangePortalCheckoutMethodDocument, variables })
    }),
    ChangePortalAvailabilityRule: build.mutation<ChangePortalAvailabilityRuleMutation, ChangePortalAvailabilityRuleMutationVariables>({
      query: (variables) => ({ document: ChangePortalAvailabilityRuleDocument, variables })
    }),
    AddPortalCustomDomain: build.mutation<AddPortalCustomDomainMutation, AddPortalCustomDomainMutationVariables>({
      query: (variables) => ({ document: AddPortalCustomDomainDocument, variables })
    }),
    VerifyPortalCustomDomain: build.mutation<VerifyPortalCustomDomainMutation, VerifyPortalCustomDomainMutationVariables>({
      query: (variables) => ({ document: VerifyPortalCustomDomainDocument, variables })
    }),
    SetPrimaryPortalCustomDomain: build.mutation<SetPrimaryPortalCustomDomainMutation, SetPrimaryPortalCustomDomainMutationVariables>({
      query: (variables) => ({ document: SetPrimaryPortalCustomDomainDocument, variables })
    }),
    RemovePortalCustomDomain: build.mutation<RemovePortalCustomDomainMutation, RemovePortalCustomDomainMutationVariables>({
      query: (variables) => ({ document: RemovePortalCustomDomainDocument, variables })
    }),
    CustomerPortalSelfRegister: build.mutation<CustomerPortalSelfRegisterMutation, CustomerPortalSelfRegisterMutationVariables>({
      query: (variables) => ({ document: CustomerPortalSelfRegisterDocument, variables })
    }),
    PortalCreateCart: build.mutation<PortalCreateCartMutation, PortalCreateCartMutationVariables>({
      query: (variables) => ({ document: PortalCreateCartDocument, variables })
    }),
    PortalUpdateCart: build.mutation<PortalUpdateCartMutation, PortalUpdateCartMutationVariables>({
      query: (variables) => ({ document: PortalUpdateCartDocument, variables })
    }),
    PortalInitializeOrder: build.mutation<PortalInitializeOrderMutation, PortalInitializeOrderMutationVariables>({
      query: (variables) => ({ document: PortalInitializeOrderDocument, variables })
    }),
    PortalAddLineItems: build.mutation<PortalAddLineItemsMutation, PortalAddLineItemsMutationVariables>({
      query: (variables) => ({ document: PortalAddLineItemsDocument, variables })
    }),
    PortalUpdateOrderStatus: build.mutation<PortalUpdateOrderStatusMutation, PortalUpdateOrderStatusMutationVariables>({
      query: (variables) => ({ document: PortalUpdateOrderStatusDocument, variables })
    }),
    PortalDeleteEmptyOrder: build.mutation<PortalDeleteEmptyOrderMutation, PortalDeleteEmptyOrderMutationVariables>({
      query: (variables) => ({ document: PortalDeleteEmptyOrderDocument, variables })
    }),
    PortalCompleteCheckout: build.mutation<PortalCompleteCheckoutMutation, PortalCompleteCheckoutMutationVariables>({
      query: (variables) => ({ document: PortalCompleteCheckoutDocument, variables })
    }),
    PortalGetNextOrderNumber: build.mutation<PortalGetNextOrderNumberMutation, PortalGetNextOrderNumberMutationVariables>({
      query: (variables) => ({ document: PortalGetNextOrderNumberDocument, variables })
    }),
    PortalCreateFavoritesList: build.mutation<PortalCreateFavoritesListMutation, PortalCreateFavoritesListMutationVariables>({
      query: (variables) => ({ document: PortalCreateFavoritesListDocument, variables })
    }),
    PortalUpdateFavoritesList: build.mutation<PortalUpdateFavoritesListMutation, PortalUpdateFavoritesListMutationVariables>({
      query: (variables) => ({ document: PortalUpdateFavoritesListDocument, variables })
    }),
    PortalDeleteFavoritesList: build.mutation<PortalDeleteFavoritesListMutation, PortalDeleteFavoritesListMutationVariables>({
      query: (variables) => ({ document: PortalDeleteFavoritesListDocument, variables })
    }),
    PortalSetFavoritesListActive: build.mutation<PortalSetFavoritesListActiveMutation, PortalSetFavoritesListActiveMutationVariables>({
      query: (variables) => ({ document: PortalSetFavoritesListActiveDocument, variables })
    }),
    MintPortalSessionHandoffCode: build.mutation<MintPortalSessionHandoffCodeMutation, MintPortalSessionHandoffCodeMutationVariables>({
      query: (variables) => ({ document: MintPortalSessionHandoffCodeDocument, variables })
    }),
    ExchangePortalSessionHandoffCode: build.mutation<ExchangePortalSessionHandoffCodeMutation, ExchangePortalSessionHandoffCodeMutationVariables>({
      query: (variables) => ({ document: ExchangePortalSessionHandoffCodeDocument, variables })
    }),
    PortalAddContact: build.mutation<PortalAddContactMutation, PortalAddContactMutationVariables>({
      query: (variables) => ({ document: PortalAddContactDocument, variables })
    }),
    PortalUpdateContact: build.mutation<PortalUpdateContactMutation, PortalUpdateContactMutationVariables>({
      query: (variables) => ({ document: PortalUpdateContactDocument, variables })
    }),
    PortalRemoveContact: build.mutation<PortalRemoveContactMutation, PortalRemoveContactMutationVariables>({
      query: (variables) => ({ document: PortalRemoveContactDocument, variables })
    }),
    PortalPlaceOrder: build.mutation<PortalPlaceOrderMutation, PortalPlaceOrderMutationVariables>({
      query: (variables) => ({ document: PortalPlaceOrderDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useUpdatePortalSettingsMutation, useChangePortalHelpContactMutation, useChangePortalCheckoutMethodMutation, useChangePortalAvailabilityRuleMutation, useAddPortalCustomDomainMutation, useVerifyPortalCustomDomainMutation, useSetPrimaryPortalCustomDomainMutation, useRemovePortalCustomDomainMutation, useCustomerPortalSelfRegisterMutation, usePortalCreateCartMutation, usePortalUpdateCartMutation, usePortalInitializeOrderMutation, usePortalAddLineItemsMutation, usePortalUpdateOrderStatusMutation, usePortalDeleteEmptyOrderMutation, usePortalCompleteCheckoutMutation, usePortalGetNextOrderNumberMutation, usePortalCreateFavoritesListMutation, usePortalUpdateFavoritesListMutation, usePortalDeleteFavoritesListMutation, usePortalSetFavoritesListActiveMutation, useMintPortalSessionHandoffCodeMutation, useExchangePortalSessionHandoffCodeMutation, usePortalAddContactMutation, usePortalUpdateContactMutation, usePortalRemoveContactMutation, usePortalPlaceOrderMutation } = injectedRtkApi;
